site.svg = {
	glass: '<svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="30" height="30" viewBox="0 0 30 30" id="searchToggle"><path d="M30 27.7L22.1 19.8 19.7 17.3C20.9 15.5 21.7 13.4 21.7 11 21.7 4.9 16.8 0 10.8 0 4.9 0 0 4.9 0 11 0 17.1 4.9 22 10.8 22 13.3 22 15.6 21.1 17.5 19.7L26.5 28.7C26.5 28.8 26.6 28.8 26.6 28.9L27.8 30 30 27.7ZM10.8 19.4C6.3 19.4 2.6 15.6 2.6 11 2.6 6.4 6.3 2.6 10.8 2.6 15.4 2.6 19.1 6.4 19.1 11 19.1 12.9 18.5 14.7 17.4 16.1 17 16.6 16.6 17 16.2 17.4 14.8 18.6 12.9 19.4 10.8 19.4Z"/></svg>',

	init: function () {
		$('#searchBox').prepend(site.svg.glass);
	}
};

site.inits.push('site.svg.init()');
